import { Link } from "@quintype/components";
import React from "react";
import User from "../other-icons/User";

import "./hamburger-myaccount-button.m.css";

function HamburgerMyAccountButton({ onAccountHandler }) {
  return (
    <div styleName="myaccount-wrapper" onClick={onAccountHandler}>
      <Link styleName="my-account-button" target="_blank">
        <User width="13px" height="13px" />
        <span>Account</span>
      </Link>
    </div>
  );
}

export default HamburgerMyAccountButton;
